import { useRef, useEffect } from "react";

import {func_validation, isArrayNotEmpty } from "functions";
import { useCustomSelector } from "hooks";
import useUserManagement from "dataflow/distributorPortal/actions/useUserManagement.actions";

export function useTableData(props) {
    const {
        tableData,
        userGroupList,
        isUserRecordUpdatedSuccessfully,
        isRenderingRequired, setIsRenderingRequired,
    } = props;

    let selectedData = useRef(func_validation.cloneArrayOfObject(userGroupList));
    let initUpdateData = useRef({});

    let { permissionDescriptions } = useCustomSelector("distributorPortal_userManagement");

    const { getPermissionDescriptions } = useUserManagement();
    useEffect(() => {
        getPermissionDescriptions();
    }, []);

    let userGroupPermissionList_formatted = [];
    if (func_validation.isArrayNotEmpty(tableData) &&
        func_validation.isArrayNotEmpty(selectedData.current)) {

        userGroupPermissionList_formatted = func_validation.deepCloneArray(tableData);
        userGroupPermissionList_formatted.map((userGroupPermissionObj, userIndex) => {
            let permissionList = func_validation.getObjectPropertyValue(userGroupPermissionObj, "PermissionList");
            let userGroupPermission = func_validation.getObjectPropertyValue(userGroupPermissionObj, "UserGroupPermission");

            // Main row
            userGroupPermissionObj["permissionName"] = userGroupPermission;
            let subrowGroups = {};
            let permissionNameList = [];
            selectedData.current.map((userGroupObj, idx) => {
                let userGroupId = func_validation.getObjectPropertyValue(userGroupObj, "ID");
                let groupPermissions = func_validation.getObjectPropertyValue(userGroupObj, "GroupPermissions");
                let selectedPermissions = {};
                groupPermissions.map((groupPermissionObj) => {
                    let permissionName = func_validation.getObjectPropertyValue(groupPermissionObj, "PermissionName");
                    selectedPermissions[permissionName] = true;
                });

                // Check if permission is set for the particular user group
                let isPermissionSetList = [];
                let isEveryPermissionSet = true;
                let originalPermissionList = [];
                permissionList.map((permissionObj) => {
                    let fullPermissionString = func_validation.getObjectPropertyValue(permissionObj, "Original");
                    originalPermissionList.push(fullPermissionString);

                    if (func_validation.getArrayLength(permissionNameList, 0) < func_validation.getArrayLength(permissionList, 0)) {
                        let permissionName = func_validation.getObjectPropertyValue(permissionObj, "Permission");

                        let permissionDescriptionObj = isArrayNotEmpty(permissionDescriptions)? permissionDescriptions.find((obj) => obj?.name === fullPermissionString):undefined;

                        permissionNameList.push({
                            permissionName,
                            permissionDescription: permissionDescriptionObj? permissionDescriptionObj?.description:""
                        });
                    }

                    if (selectedPermissions[fullPermissionString])
                        isPermissionSetList.push(true);
                    else {
                        isPermissionSetList.push(false);
                        isEveryPermissionSet = false;
                    }
                });
                
                userGroupPermissionObj["group" + idx] = {
                    "userGroupId": userGroupId,
                    "isEveryPermissionSet": isEveryPermissionSet,
                    "userGroupPermissionName": userGroupPermission,
                };

                subrowGroups["group" + idx] = {
                    "userGroupId": userGroupId,
                    "isPermissionSetList": isPermissionSetList,
                    "permissionList": originalPermissionList,
                };
            });

            userGroupPermissionObj["subRows"] = [{
                "permissionName": permissionNameList,
                ...subrowGroups,
            }]
        })
    }

    useEffect(() => {
        let userGroupList_new = func_validation.cloneArrayOfObject(userGroupList);
        setIsRenderingRequired(!isRenderingRequired);
        selectedData.current = userGroupList_new;

        if (func_validation.isArrayNotEmpty(userGroupList)) {

            let initUpdateData_new = {};
            userGroupList.map((userGroupObj) => {
                let userGroupId = func_validation.getObjectPropertyValue(userGroupObj, "ID");
                initUpdateData_new[userGroupId] = {};
                let groupPermissions = func_validation.getObjectPropertyValue(userGroupObj, "GroupPermissions");

                if (func_validation.isArrayNotEmpty(groupPermissions)) {
                    groupPermissions.map((permissionObj) => {
                        let id = func_validation.getObjectPropertyValue(permissionObj, "ID");
                        let permissionName = func_validation.getObjectPropertyValue(permissionObj, "PermissionName");

                        initUpdateData_new[userGroupId][permissionName] = id;
                    })
                }
            })

            setIsRenderingRequired(!isRenderingRequired);
            initUpdateData.current = initUpdateData_new;
        }
    }, [JSON.stringify(userGroupList)]);

    useEffect(() => {
        if (props.getUserGroupList)
            props.getUserGroupList();
    }, [isUserRecordUpdatedSuccessfully]);

    return {
        userGroupPermissionList_formatted,
        selectedData, initUpdateData
    }
}